(async () => {
    const { Core } = await importModule('Core');
    const PREFIX_BUY_WITH = 'buy_with_';
    const LINE_ITEM_PROPS_REGEXP = /(?<=\[).+?(?=\])/;

    customElements.define('product-form', class extends Core {

        elements = {
            formTargeter: '[data-product-form-targeter]',
            toCartButton: 'product-to-cart'
        }
        _submitHandlerRef = this._submitHandler.bind(this)

        render() {
            if (!this.$formTargeter) return; 
            this.$form = this.$formTargeter.form;
            this.$form?.addEventListener('submit', this._submitHandlerRef);
        }

        _submitHandler(e) {
            e.preventDefault();
            this.$toCartButton.addToCart(this.cartItems, this.mainVariantId);
        }

        _isVariantInput([ inputName, value ]) {
            if (inputName === 'selling_plan') this._setSellingPlan(value);
            return inputName.includes(PREFIX_BUY_WITH) || inputName === 'id';
        }
        
        _setSellingPlan(id) {
            this.sellingPlanId = id;
        }

        
        _setCartItem([ inputName, value ]) {
            if (inputName === 'id') this.mainVariantId = value;
            const sellingPlanId = this.sellingPlanId || '';
            return {
                id: value,
                quantity: this._getItemQty(inputName),
                selling_plan: inputName === 'id' ? sellingPlanId : '',
                properties: this._getProperties(inputName)
            }
        }

        _getItemQty(inputName) {
            return inputName === 'id' ? this.qty : 1;
        }
        _getProperties(inputName) {
            return inputName === 'id' ? this.properties : {};
        }

        get cartItems() {
            return Array.from(this.formData.entries())
                .filter(this._isVariantInput.bind(this))
                .map(this._setCartItem.bind(this))
        }

        get formData() {
            return new FormData(this.$form);
        }

        get qty() {
            return +this.formData.get('quantity') || 1;
        }
        get properties() {
            return Array.from(this.formData.entries()).reduce((acc, [key, val]) => {
                if (key.startsWith('properties[') && key.endsWith(']') && val) {
                    const propKey = key.match(LINE_ITEM_PROPS_REGEXP)[0];
                    acc[propKey] = val;
                }
                return acc;
            }, {});
        }

        disconnect() {
            this.$form?.removeEventListener('submit', this._submitHandlerRef);
        }
    })
})();



document.addEventListener("DOMContentLoaded", function () {

  function getNLTime() {
    return new Date(new Date().toLocaleString("en-US", {
      timeZone: "Europe/Amsterdam"
    }));
  }

  function formatDate(date) {
    return date.toLocaleDateString("nl-NL", {
      weekday: 'short',
      day: '2-digit',
      month: 'short'
    });
  }

  function calculateDates() {

    let now = getNLTime();
    let orderDate = new Date(now);

    let day = orderDate.getDay(); // 0=Sun, 1=Mon

    // EXACT table logic
    const shippingMap = {
      1: 1, // Mon → Tue
      2: 1, // Tue → Wed
      3: 1, // Wed → Thu
      4: 1, // Thu → Fri
      5: 3, // Fri → Mon
      6: 2, // Sat → Mon
      0: 2  // Sun → Tue
    };

    const deliveryMap = {
      1: 2, // Mon → Wed
      2: 2, // Tue → Thu
      3: 2, // Wed → Fri
      4: 2, // Thu → Sat
      5: 4, // Fri → Tue
      6: 3, // Sat → Tue
      0: 3  // Sun → Wed
    };

    let shipDate = new Date(orderDate);
    shipDate.setDate(orderDate.getDate() + shippingMap[day]);

    let deliveryDate = new Date(orderDate);
    deliveryDate.setDate(orderDate.getDate() + deliveryMap[day]);

    document.getElementById("order-date").innerText = formatDate(orderDate);
    document.getElementById("ship-date").innerText = formatDate(shipDate);
    document.getElementById("delivery-date").innerText = formatDate(deliveryDate);
  }

  calculateDates();

});